import React from 'react';

import PropTypes from 'prop-types';

import DestroyModal from 'components/application/DestroyModal';

import { useCurrentActor } from 'components/contexts/CurrentActor';

import RedInfoIcon from '-!svg-react-loader?name=RedInfoIcon!icons/info-red.svg';

export default function DestroyProjectModal({
  isDestroyProjectDisabled = false,
  onClose,
  onDestroyProjectSubmit,
  project,
}) {
  const currentActor = useCurrentActor();

  return (
    <DestroyModal
      additionalContent={
        <div className='tw-m-0 tw-mt-5 tw-flex tw-items-center tw-gap-3 tw-rounded-lg tw-border-0 tw-bg-red-025 tw-p-3 tw-text-red-800'>
          <RedInfoIcon
            className='[&_path]:tw-fill-red-800'
            height='16px'
            width='16px'
          />
          <p className='tw-m-0'>
            This action is permanent and{' '}
            <strong className='tw-font-semibold'>cannot be undone.</strong>
          </p>
        </div>
      }
      confirmationText={`Delete ${currentActor.division.attributes.singularRAMSName || 'RAMS'}`}
      displayText={`Delete ${project.attributes.name}`}
      isDestroyDisabled={isDestroyProjectDisabled}
      isOpen={true}
      onClose={onClose}
      onDestroy={() => onDestroyProjectSubmit({ id: project.id })}
    />
  );
}

DestroyProjectModal.propTypes = {
  isDestroyProjectDisabled: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onDestroyProjectSubmit: PropTypes.func.isRequired,
  project: PropTypes.object.isRequired,
};
